import { NavigateButton } from '@/components';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import { useTranslation } from 'react-i18next';

export const NavigationLabelButton = () => {
  const { t } = useTranslation();

  return (
    <TenantManagerResourceGuard>
      <NavigateButton
        path="/tenant-manager/label"
        fullPath
        text={t('hierarchy-labels-page')}
      />
    </TenantManagerResourceGuard>
  );
};
